export default "__VITE_ASSET__9dOT29bZ__"